import Grid from "components/primitives/Grid";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { ChartLegendItemColorBlock } from "./ChartLegendItem.components";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import * as Components from "./ChartLegendItem.components";

interface ChartLegendItemProps {
  color?: string;
  label: string;
  removeItem?(): void;
}

function ChartLegendItem(props: ChartLegendItemProps) {
  const { t } = useTranslation();

  return (
    <Components.GridContainer
      container
      borderRadius="8px"
      boxSizing="border-box"
      alignItems="center"
      wrap="nowrap"
      width="100%"
    >
      <Grid>
        <ChartLegendItemColorBlock color={props.color} />
      </Grid>
      <Grid size="grow" title={props.label} minWidth={0}>
        <Typography noWrap data-sensitive>
          {props.label}
        </Typography>
      </Grid>
      {props.removeItem && (
        <Components.RemoveButtonGrid>
          <IconButton size="small" onClick={props.removeItem} aria-label={t("global.remove_item_aria_label")}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Components.RemoveButtonGrid>
      )}
    </Components.GridContainer>
  );
}

export default ChartLegendItem;
